import React from 'react'
import PropTypes from 'prop-types'
import { Form as FinalForm } from 'react-final-form'

import { RailsForm } from '@support/RailsForm'
import { validate } from '@models/admin/organizationContacts'
import Form from './Form'

const Edit = ({ model, organization, o }) =>
  <RailsForm
    component={FinalForm}
    action='update'
    url={`/v4/o/${o}/admin/organizations/${organization.id}/contacts/${model.id}`}
    successUrl={`/v4/o/${o}/admin/organizations/${organization.id}/contacts`}
    validate={validate}
    initialValues={model}
    render={(props) => (
      <Form
        {...props}
        title={I18n.t('v4/organization_contact.actions.edit')}
        organization={organization}
        o={o}
      />
    )}
  />

Edit.propTypes = {
  model: PropTypes.object,
  organization: PropTypes.object,
  o: PropTypes.string
}

export default Edit
